import {
  getAccessToken,
  getRefreshToken,
} from "src/utils/authentication.service";

// eslint-disable-next-line no-undef
const cleverstoryAppUrl = process.env.REACT_APP_CLEVERSTORY_APP_URL;

export const buildCreationTargetPath = (
  workspaceId: string,
  templateId: string,
  name: string,
  listId: string | null,
  isPromptEditor?: boolean,
): string => {
  const params = new URLSearchParams({ name });
  if (listId) params.set("list", listId);
  if (isPromptEditor) params.set("isPromptEditor", "true");
  return `/app/${workspaceId}/storyboards/templates/${templateId}/create?${params.toString()}`;
};

export const buildPageTargetPath = (
  workspaceId: string,
  pageId: string,
): string => `/app/${workspaceId}/pages/${pageId}`;

export const buildPagePreviewPath = (
  workspaceId: string,
  pageId: string,
): string => `/app/${workspaceId}/pages/${pageId}/preview`;

export const buildCleverstoryUrl = (targetPath: string): string => {
  if (!cleverstoryAppUrl) {
    // eslint-disable-next-line no-console
    console.error(
      "REACT_APP_CLEVERSTORY_APP_URL is not set; cannot build Cleverstory redirect URL.",
    );
    return "";
  }

  const at = getAccessToken();
  const rt = getRefreshToken();

  if (!at || !rt) {
    return `${cleverstoryAppUrl}${targetPath}`;
  }

  const params = new URLSearchParams({ at, rt, next: targetPath });
  const redirectUrl =`${cleverstoryAppUrl}/__login__/me?${params.toString()}`;
  return redirectUrl
};
